import { styled } from '@mui/material/styles';
import { Drawer, Toolbar, Box, List, ListItemIcon, Divider } from '@mui/material';

export const SidebarDrawer = styled(Drawer)(({ theme }) => ({
  width: 240,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: 240,
    boxSizing: 'border-box',
  },
}));

export const SidebarToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: 32,
}));

export const LogoBox = styled(Box)(({ theme }) => ({
  paddingInlineStart: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(6),
}));

export const LogoImage = styled('img')({
  width: 135,
  height: 54,
  marginBottom: 4,
});

export const LogoText = styled(Box)(({ theme }) => ({
  color: '#0076FF',
  fontWeight: 700,
  fontSize: 16,
  fontFamily: 'PF DIN Text Pro',
  letterSpacing: 0.5,
  marginBottom: theme.spacing(1),
}));

export const SidebarList = styled(List)(({ theme }) => ({
  paddingInlineStart: theme.spacing(2),
  paddingInlineEnd: theme.spacing(3),
}));

export const SidebarListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 32,
  marginRight: theme.spacing(1),
}));

export const SidebarDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.grey[800],
}));
